import authActions from "./actions";

const initialState = {
  candidateTokenDetails:null,
  candidateInfo:null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case authActions.CANDIDATE_LOGIN:
      return{
        ...state,
        candidateTokenDetails:action.payload,
      };
       case authActions.RPT_CANDIDATE_LOGIN:
      return{
        ...state,
          candidateInfo:action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
